import React, { useState } from 'react';
import { Star, Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import AnimatedSection from './AnimatedSection';

export default function Reviews() {
  const [activeIndex, setActiveIndex] = useState(0);

  // Etats pour la gestion du "swipe" / "drag"
  const [startX, setStartX] = useState<number | null>(null);
  const [endX, setEndX] = useState<number | null>(null);

  const reviews = [
    {
      name: "Theo",
      role: "Membre",
      image: "https://cdn.discordapp.com/avatars/526740196738334731/99b286289bd9c6aca937903067059bd3.webp?size=80",
      content: "Une nouvelle communauté qui annonce du gros ! Anthony est un trader dont on a beaucoup à apprendre 🔥",
      rating: 5
    },
    {
      name: "Thomas",
      role: "Membre",
      image: "https://cdn.discordapp.com/avatars/295991683101884416/b47846fabaad181638cfb43606cd9147.webp?size=80",
      content: "Sympa. Il n'y a pas énormément de monde donc ça permet d'être vraiment en contact avec Anthony, le trader, ce qui change des autres groupes.",
      rating: 5
    },
    {
      name: "Mouna",
      role: "Membre",
      image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSa4W0-BI5CUx35ovhgfEqbeDo9obGXOMgEtg&s",
      content: "Enfin!! je suis tombé sur un service de qualité je ne regrette vraiment pas de faire parti de cette magnifique communauté !",
      rating: 5
    },
    {
      name: "Hiken",
      role: "Membre",
      image: "https://cdn.discordapp.com/avatars/332492950338666496/063af53ff77811ef24528c3d049e8fbb.webp?size=80",
      content: "+1600€ en 3 semaines !! Grâce à Anthony, j’ai pu saisir des super opportunités sur les marchés ! Simple à suivre et vraiment efficace 📈💪.",
      rating: 5
    },
    {
      name: "Dos Santos",
      role: "Forex Trader",
      image: "https://cdn.discordapp.com/attachments/1086015005863972997/1330605722068713694/jp.jpg?ex=67972865&is=6795d6e5&hm=484d55d18286026b6a74393124415d07cc8934a697adbd188e7f045dd17885eb&",
      content: "Je suis très heureux d’avoir rejoins cette incroyable communauté de trading, de signaux et de formation. j’ai déjà obtenu d’excellents résultats qui m’encouragent à aller encore plus loin. Avec les outils, les analyses, et le soutien proposés, je suis convaincu que je vais pouvoir continuer à progresser et atteindre mes objectifs. Hâte de partager à l’avenir et de continuer à performer.",
      rating: 5
    }
  ];

  const nextSlide = () => {
    setActiveIndex((current) => (current + 1) % reviews.length);
  };

  const prevSlide = () => {
    setActiveIndex((current) => (current - 1 + reviews.length) % reviews.length);
  };

  // ===================
  // GESTION DU SWIPE TOUCH
  // ===================
  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    setStartX(e.targetTouches[0].clientX);
    setEndX(null);
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (startX === null) return;
    setEndX(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (startX === null || endX === null) return;
    const diff = startX - endX;
    const threshold = 50; // Seuil de "swipe" en px

    if (diff > threshold) {
      // Swipe vers la gauche => next
      nextSlide();
    } else if (diff < -threshold) {
      // Swipe vers la droite => prev
      prevSlide();
    }

    setStartX(null);
    setEndX(null);
  };

  // ===================
  // GESTION DU DRAG SOURIS
  // ===================
  const handleMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
    setStartX(e.clientX);
    setEndX(null);
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (startX === null) return;
    setEndX(e.clientX);
  };

  const handleMouseUp = (e: React.MouseEvent<HTMLDivElement>) => {
    if (startX === null || endX === null) return;
    const diff = startX - endX;
    const threshold = 50; // Seuil de "drag" en px

    if (diff > threshold) {
      // Drag vers la gauche => next
      nextSlide();
    } else if (diff < -threshold) {
      // Drag vers la droite => prev
      prevSlide();
    }

    setStartX(null);
    setEndX(null);
  };

  // Optionnel : si la souris sort du composant avant "mouseUp", on remet tout à zéro
  const handleMouseLeave = () => {
    if (startX !== null && endX !== null) {
      const diff = startX - endX;
      if (diff > 50) nextSlide();
      else if (diff < -50) prevSlide();
    }
    setStartX(null);
    setEndX(null);
  };

  return (
    <section id="reviews" className="py-24 bg-white relative overflow-hidden">
      {/* Subtle gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-50 to-white" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <AnimatedSection>
          <div className="text-center mb-16">
            <span className="text-purple-600 font-semibold text-lg mb-4 block">TÉMOIGNAGES</span>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              Ce que disent
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-purple-800">
                nos traders
              </span>
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Découvrez les expériences de notre communauté de traders performants
            </p>
          </div>
        </AnimatedSection>

        <div className="relative">
          {/* Container avec gestion du swipe/drag */}
          <div
            className="overflow-hidden select-none" 
            // "select-none" pour empêcher la sélection de texte quand on glisse
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={handleMouseUp}
            onMouseLeave={handleMouseLeave}
          >
            <div
              className="flex transition-transform duration-500 ease-out"
              style={{ transform: `translateX(-${activeIndex * 100}%)` }}
            >
              {reviews.map((review, index) => (
                <div key={index} className="w-full flex-shrink-0 px-4">
                  <div className="relative group">
                    <div className="absolute -inset-0.5 bg-gradient-to-r from-purple-600/50 to-purple-800/50 rounded-2xl blur opacity-0 group-hover:opacity-100 transition duration-1000" />
                    <div className="relative bg-white p-8 rounded-2xl shadow-lg border border-purple-100 group-hover:border-purple-200 transition-colors duration-300">
                      <Quote className="w-10 h-10 text-purple-500 mb-4 opacity-50" />
                      <p className="text-gray-700 mb-6 text-lg leading-relaxed">
                        {review.content}
                      </p>
                      <div className="flex mb-4">
                        {[...Array(review.rating)].map((_, i) => (
                          <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                        ))}
                      </div>
                      <div className="flex items-center">
                        <div className="relative">
                          <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-purple-800 rounded-full blur-sm opacity-0 group-hover:opacity-50 transition-opacity duration-300" />
                          <img
                            src={review.image}
                            alt={review.name}
                            className="w-14 h-14 rounded-full object-cover relative ring-2 ring-purple-100 group-hover:ring-purple-300 transition-all duration-300"
                          />
                        </div>
                        <div className="ml-4">
                          <h4 className="text-gray-900 font-semibold text-lg">{review.name}</h4>
                          <p className="text-purple-600">{review.role}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Boutons de navigation */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white hover:bg-purple-50 text-purple-600 p-3 rounded-full transform transition-all duration-200 hover:scale-110 shadow-lg hover:shadow-purple-100 z-10"
          >
            <ChevronLeft className="w-6 h-6" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white hover:bg-purple-50 text-purple-600 p-3 rounded-full transform transition-all duration-200 hover:scale-110 shadow-lg hover:shadow-purple-100 z-10"
          >
            <ChevronRight className="w-6 h-6" />
          </button>

          {/* Dots de navigation */}
          <div className="flex justify-center mt-8 gap-2">
            {reviews.map((_, index) => (
              <button
                key={index}
                onClick={() => setActiveIndex(index)}
                className={`h-2.5 rounded-full transition-all duration-300 ${
                  index === activeIndex 
                    ? 'bg-purple-600 w-8' 
                    : 'bg-purple-200 w-2.5 hover:bg-purple-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
